const EventProduct = ({ entity }) => {
  return 'event';
};

export default EventProduct;
